import React from 'react';
import Main from '../../components/main';
import Box from '../../components/box';
import H1 from '../../components/h1';
import P from '../../components/p';
import Button from '../../components/button';

const NotFound = () => (
  <Main>
    <Box>
      <H1>Page Not Found</H1>
      <P>Sorry, this page could not be found.</P>
      <Button href="/">Back to Home</Button>
    </Box>
  </Main>
);

export default NotFound;



/** WEBPACK FOOTER **
 ** ./src/views/pages/not-found/index.js
 **/